import type { FC } from 'react';
import { useEffect, useRef } from 'react';

import { useSubscriptionTechnicalName, useUserInfo } from 'state/appState/appStateHooks';

// Public Heap app ID, hardcoded like the Pendo/Intercom IDs (it ships in the client bundle).
const HEAP_APP_ID = '1196343873';

interface HeapApi {
  load: (envId: string) => void;
  identify: (identity: string) => void;
  resetIdentity: () => void;
  addUserProperties: (properties: Record<string, unknown>) => void;
  addAccountProperties: (properties: Record<string, unknown>) => void;
}

declare global {
  interface Window {
    heap?: HeapApi;
  }
}

export const HeapContainer: FC = () => {
  const userInfo = useUserInfo();
  const subscriptionName = useSubscriptionTechnicalName();

  const { sub, fullName, username } = userInfo;

  // Load the Heap script only once.
  const hasLoadedRef = useRef(false);

  useEffect(() => {
    const heap = window.heap;

    if (!username || !heap) {
      return;
    }

    if (!hasLoadedRef.current) {
      heap.load(HEAP_APP_ID);
      hasLoadedRef.current = true;
    }

    heap.identify(sub);
    heap.addUserProperties({ email: username, name: fullName, subscription: subscriptionName });
    heap.addAccountProperties({ id: subscriptionName });
  }, [sub, fullName, username, subscriptionName]);

  return null;
};
